import React, { useEffect, useRef, useState } from "react";
import * as d3 from "d3";
import { getTotalDrivenVehicle } from "../../../services/summary/summaryService";

// 🔁 CHANGE THIS IF NEEDED
const ANIMATION_TYPE = "morph";

const MultiLineChart = ({
  title = "Vehicle Trend",
  filterdata,
  activeTab
}) => {

  const [graphData, setGraphData] = useState([]);

  useEffect(() => {
    if (filterdata?.startDate && filterdata?.endDate && filterdata?.vehicle) {
      getGraphFunction();
    }
  }, [filterdata.startDate, filterdata.endDate, filterdata.vehicle,activeTab]);

  async function getGraphFunction() {
    await getTotalDrivenVehicle({ filterdata,activeTab })
      .then(res => {
        setGraphData(res)
      })
      .catch(err => console.log("err"))
  }

  const svgRef = useRef();
  const wrapperRef = useRef();

  useEffect(() => {

    const svg = d3.select(svgRef.current);
    svg.selectAll("*").remove();

    if (!graphData || graphData.length === 0) {
      svg
        .attr("width", 600)
        .attr("height", 300)
        .append("text")
        .attr("x", 300)
        .attr("y", 150)
        .attr("text-anchor", "middle")
        .attr("font-size", "14px")
        .attr("fill", "#777")
        .text("No Data Available");

      return;
    }

    const allZero = graphData.every(
      d => (d.Total_Vehicles || 0) === 0 && (d.Driven_Vehicles || 0) === 0
    );

    if (allZero) {
      svg
        .attr("width", 600)
        .attr("height", 300)
        .append("text")
        .attr("x", 300)
        .attr("y", 150)
        .attr("text-anchor", "middle")
        .attr("font-size", "14px")
        .attr("fill", "#777")
        .text("No Data Available");

      return;
    }

    const width = wrapperRef.current?.offsetWidth || 600;
    const height = 300;

    const margin = { top: 60, right: 30, bottom: 40, left: 50 };
    const innerWidth = width - margin.left - margin.right;
    const innerHeight = height - margin.top - margin.bottom;

    const g = svg
      .attr("width", width)
      .attr("height", height)
      .append("g")
      .attr("transform", `translate(${margin.left},${margin.top})`);

    svg.append("text")
      .attr("x", width / 2)
      .attr("y", 20)
      .attr("text-anchor", "middle")
      .attr("font-size", "14px")
      .attr("font-weight", "600")
      .text(title);

    const labelGroup = svg.append("g")
      .attr("transform", `translate(${margin.left},40)`);

    const colors = {
      Total_Vehicles: "#4e79a7",
      Driven_Vehicles: "#f28e2b",
    };

    const legendData = [
      { label: "Total_Vehicles", color: colors.Total_Vehicles },
      { label: "Driven_Vehicles", color: colors.Driven_Vehicles },
    ];

    const legend = svg.append("g")
      .attr("transform", `translate(${width / 2 - 60}, 50)`);

    const legendItem = legend.selectAll(".legend-item")
      .data(legendData)
      .enter()
      .append("g")
      .attr("class", "legend-item")
      .attr("transform", (d, i) => `translate(${i * 120}, 0)`);

    legendItem.append("circle")
      .attr("cx", 0)
      .attr("cy", 0)
      .attr("r", 5)
      .attr("fill", d => d.color);

    legendItem.append("text")
      .attr("x", 10)
      .attr("y", 4)
      .attr("font-size", "12px")
      .attr("font-weight", "500")
      .text(d => d.label);

    const xScale = d3
      .scalePoint()
      .domain(graphData.map(d => d.date))
      .range([0, innerWidth])
      .padding(0.5);

    const maxValue =
      d3.max(graphData, d => Math.max(d.Total_Vehicles, d.Driven_Vehicles)) || 10;

    const yScale = d3
      .scaleLinear()
      .domain([0, maxValue + 10])
      .range([innerHeight, 0]);

    const xAxis = g.append("g")
      .attr("transform", `translate(0,${innerHeight})`)
      .call(d3.axisBottom(xScale));

    xAxis.selectAll("text")
      .attr("transform", "rotate(-30)")
      .style("text-anchor", "end");

    g.append("g").call(d3.axisLeft(yScale));

    const line = key =>
      d3.line()
        .x(d => xScale(d.date))
        .y(d => yScale(d[key]))
        .curve(d3.curveMonotoneX);

    if (ANIMATION_TYPE === "morph") {
      ["Total_Vehicles", "Driven_Vehicles"].forEach(key => {
        g.selectAll(`circle-${key}`)
          .data(graphData)
          .enter()
          .append("circle")
          .attr("cx", d => xScale(d.date))
          .attr("cy", yScale(0))
          .attr("r", 4)
          .attr("fill", colors[key])
          .transition()
          .delay((_, i) => i * 200)
          .duration(600)
          .ease(d3.easeCubicOut)
          .attr("cy", d => yScale(d[key]));

        g.append("path")
          .datum(graphData)
          .attr("fill", "none")
          .attr("stroke", colors[key])
          .attr("stroke-width", 2)
          .attr("opacity", 0)
          .attr("d", line(key))
          .transition()
          .delay(1200)
          .duration(600)
          .attr("opacity", 1);
      });
    }

  }, [graphData]);

  return (
    <div ref={wrapperRef} style={{ width: "100%" }}>
      <svg ref={svgRef} />
    </div>
  );
};

export default MultiLineChart;